import React from 'react';
import Routes from './routes';
import ApolloWrapper from './apollo';
import Auth from './auth';
import { ThemeProvider } from '@mui/material/styles';
import whiteTheme from './theme/whiteTheme';
import { CssBaseline } from '@mui/material';
import gtmInitialize from './gtm';
import { useEffect } from 'react';
import { initialise as errorHandlerInitalise } from './errorHandler';
import { subscribeToAuthEvents } from 'helpers/authHelper';
import AppWrapper from 'components/appWrapper';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

errorHandlerInitalise();
gtmInitialize();

const App = () => {
  useEffect(() => {
    subscribeToAuthEvents();
  }, []);
  return (
    <ThemeProvider theme={whiteTheme}>
      <CssBaseline />
      <AppWrapper>
        <GoogleReCaptchaProvider
          reCaptchaKey={import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY}
          container={{
            element: 'my-recaptcha-container',
            parameters: {
              badge: 'bottomleft',
            },
          }}
        >
          <div id="my-recaptcha-container"></div>
          <ApolloWrapper>
            <Auth>
              <Routes />
            </Auth>
          </ApolloWrapper>
        </GoogleReCaptchaProvider>
      </AppWrapper>
    </ThemeProvider>
  );
};

export default App;
